import styled from 'styled-components';

export const Place = styled.div`
  width: 200px;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  margin: 0; //-25px auto 30px;
  &.noabs {
    position: relative;
    left: auto;
    top: auto;
    width: auto;
    margin: 0 10px 0 0;
  }
`;

export const Button = styled.button`
  display: inline-block;
  cursor: pointer;
  height: 26px;
  padding: 0 7px;
  margin: 0 3px;
  border-radius: 40px;
  line-height: 0.8;
  border: none;
  outline: none;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2), inset 0 0px 30px 0 rgba(0, 0, 0, 0.6);
  transition: 0.3s all ease-out;
  &.active {
    background: #fff;
    box-shadow: 0px 0px 2px 1px rgba(255, 255, 255, 0.3), inset 0 0px 30px 0 rgba(63, 63, 63, 0.2);
    &:hover {
      background: #fff;
      cursor: default;
      box-shadow: none;
    }
  }
  &:hover {
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.33), inset 0 0px 30px 0 rgba(0, 0, 0, 0.3);
  }
`;
